import _ from 'lodash';
import { createSelector } from 'reselect';
import { getEditBabyId } from './ui';

const getBabies = state => state.babies;

const getBabiesSortedByName = createSelector(getBabies, babies =>
  _.sortBy(Object.values(babies), 'name')
);

const getEditingBaby = createSelector(
  getBabies,
  getEditBabyId,
  (babies, babyId) => babies[babyId]
);

export { getBabies, getBabiesSortedByName, getEditingBaby };
